export default __webpack_public_path__ + "static/media/Purple_background.c35ebeba.png";